import { render, staticRenderFns } from "./TabPersonel.vue?vue&type=template&id=64bba05c&"
import script from "./TabPersonel.vue?vue&type=script&lang=js&"
export * from "./TabPersonel.vue?vue&type=script&lang=js&"
import style0 from "./TabPersonel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports